import * as React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    VerificationService,
    VerificationStepsEnum,
    FormFooterComponent,
} from '@sheerid/jslib';
import { LogoComponent } from '../LogoComponent/LogoComponent';
import { isRenderedInIframe } from '../IsRenderedInIframe';

const DOC_UPLOAD_POLL_DURATION = 20000;
const SSO_POLL_DURATION = 5000;

interface StepPendingProps {
    verificationService: VerificationService;
    intl: any;
}

const StepPending = ({ verificationService, intl }: StepPendingProps) => {
    const programId = verificationService.programId;
    const previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
    const verificationId = verificationService.verificationResponse.verificationId;
    const renderedInIframe = isRenderedInIframe();

    const isPreviousStepSSO = (): boolean => {
        if (previousVerificationResponse && previousVerificationResponse.currentStep === VerificationStepsEnum.sso) {
            return true;
        }
        return false;
    };

    const pollForVerificationServiceUpdates = () => setTimeout(
        () => {
            verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse);
        },
        isPreviousStepSSO() ? SSO_POLL_DURATION : DOC_UPLOAD_POLL_DURATION,
    );

    pollForVerificationServiceUpdates();

    return (
        <div id="sid-step-pending" className={`${!renderedInIframe ? 'sid-l-container' : ''}`}>
            <div className="sid-header">
            <div className={`sid-logo sid-l-horz-center ${renderedInIframe ? 'sid-lightbox__logo' : ''}`}>
                    <LogoComponent verificationService={verificationService} />
                </div>
                <div className={`sid-header__title sid-l-horz-center ${renderedInIframe ? 'sid-lightbox__title' : ''}`}>
                    <FormattedHTMLMessage id="step.pending.title" defaultMessage="Upload Success" />
                </div>
            </div>
            <div className={`sid-l-container ${renderedInIframe ? 'sid-lightbox' : ''}`}>
                <div className="sid-header sid-l-horz-center">

                    <div className="sid-header__subtitle-one">
                        <FormattedHTMLMessage
                            id="step.pending.subtitle"
                            defaultMessage="<strong>Your document has uploaded successfully.</strong> The review process has now started. You will be contacted via email in less than 20 minutes with details regarding your verification request."
                        />
                    </div>
                    <div className="sid-header__subtitle-two sid-l-space-top-md">
                        <FormattedHTMLMessage
                            id="step.pending.subtitle2"
                            defaultMessage="NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message."
                        />
                    </div>
                    <div className="sid-l-space-top-lg"></div>
                </div>

                <FormFooterComponent verificationService={verificationService}>
                </FormFooterComponent>
            </div>
        </div>
    );
};

export const StepPendingComponent = injectIntl(StepPending);
